import request from '@/utils/request'
import qs from 'qs'

// 获取登陆验证码图片
export function GetCodeImg() {
  return request({
    url: '/login/code/image'
  })
}
// 登陆
export function Login(data) {
  return request({
    url: '/login/oauth/token?grant_type=password',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  })
}
// 重新获取token
export function getRefeshToken(data) {
  return request({
    url: '/login/oauth/token?grant_type=refresh_token',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  })
}
